// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* add-card.component.scss */
.card-form-container {
  padding: 24px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 16px;
  box-sizing: border-box;
}

.form-header {
  text-align: center;
  margin-bottom: 32px;
}
.form-header .title {
  font-size: 28px;
  font-weight: 600;
  color: #1a1f36;
  margin-bottom: 8px;
}
.form-header .subtitle {
  font-size: 15px;
  color: #697386;
  margin-bottom: 16px;
}
.form-header .accepted-cards {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #697386;
  font-size: 14px;
}
.form-header .accepted-cards i {
  font-size: 16px;
  color: #ff5757;
}

.card-form .card-wrapper {
  background-color: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  position: relative;
  box-sizing: border-box;
  width: 100%;
}
.card-form .secure-badge {
  position: absolute;
  top: -12px;
  right: 16px;
  background: #f7fafc;
  border: 1px solid #e6e9ef;
  border-radius: 20px;
  padding: 6px 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #697386;
}
.card-form .secure-badge i {
  color: #ff5757;
  font-size: 14px;
}
.card-form .card-field {
  margin-bottom: 20px;
  width: 100%;
}
.card-form .card-field:last-child {
  margin-bottom: 0;
}
.card-form .card-field:last-child .ant-form-item-control-input {
  max-width: 160px;
}
.card-form .card-field:nth-child(2) .ant-form-item-control-input {
  max-width: 160px;
}
.card-form .stripe-element {
  background-color: #ffffff;
  border: 1px solid #e6e9ef;
  border-radius: 8px;
  padding: 12px;
  transition: all 0.2s ease;
  width: 100%;
  box-sizing: border-box;
}
.card-form .stripe-element:hover {
  border-color: #ff5757;
}
.card-form .stripe-element.StripeElement--focus {
  border-color: #ff5757;
  box-shadow: 0 0 0 3px rgba(255, 87, 87, 0.15);
}
.card-form .stripe-element.StripeElement--invalid {
  border-color: #ff5757;
  box-shadow: 0 0 0 3px rgba(255, 87, 87, 0.1);
}

.form-footer {
  margin-top: 24px;
  display: flex;
  justify-content: center;
}
.form-footer button {
  min-width: 200px;
}

:host ::ng-deep .ant-form-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  width: 100%;
}
:host ::ng-deep .ant-form-item .ant-form-item-label {
  text-align: left;
  margin-bottom: 8px;
  padding: 0;
}
:host ::ng-deep .ant-form-item .ant-form-item-label > label {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #1a1f36;
  font-weight: 500;
}
:host ::ng-deep .ant-form-item .ant-form-item-label > label::after {
  display: none;
}
:host ::ng-deep .ant-form-item .ant-form-item-control {
  min-height: unset;
}
:host ::ng-deep .ant-form-item-control-input {
  min-height: unset;
}
:host ::ng-deep .ant-form-item-explain-error {
  font-size: 13px;
  color: #ff5757;
  margin-top: 6px;
}
:host ::ng-deep .ant-btn-primary {
  background-color: #ff5757;
  border-color: #ff5757;
}
:host ::ng-deep .ant-btn-primary:hover {
  background-color: #ff7070 !important;
  border-color: #ff7070 !important;
}
:host ::ng-deep .ant-btn-primary:active {
  background-color: #e64d4d !important;
  border-color: #e64d4d !important;
}

@media (max-width: 480px) {
  .card-form-container {
    padding: 16px;
  }
  .card-form .card-wrapper {
    padding: 20px;
  }
  .card-form .card-field:last-child .ant-form-item-control-input, .card-form .card-field:nth-child(2) .ant-form-item-control-input {
    max-width: 100%;
  }
  .form-header .title {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/main/billing/add-card/add-card.component.scss"],"names":[],"mappings":"AAAA,4BAAA;AACA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AAEE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AADJ;AAGI;EACE,eAAA;EACA,cAAA;AADN;;AAOE;EACE,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AAJJ;AAOE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AALJ;AAOI;EACE,cAAA;EACA,eAAA;AALN;AASE;EACE,mBAAA;EACA,WAAA;AAPJ;AASI;EACE,gBAAA;AAPN;AAYM;EACE,gBAAA;AAVR;AAgBM;EACE,gBAAA;AAdR;AAmBE;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,sBAAA;AAjBJ;AAmBI;EACE,qBAAA;AAjBN;AAoBI;EACE,qBAAA;EACA,6CAAA;AAlBN;AAqBI;EACE,qBAAA;EACA,4CAAA;AAnBN;;AAwBA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;AArBF;AAuBE;EACE,gBAAA;AArBJ;;AA0BE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;AAvBJ;AAyBI;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;AAvBN;AAyBM;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAvBR;AAyBQ;EACE,aAAA;AAvBV;AA4BI;EACE,iBAAA;AA1BN;AA8BE;EACE,iBAAA;AA5BJ;AA+BE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AA7BJ;AAgCE;EACE,yBAAA;EACA,qBAAA;AA9BJ;AAgCI;EACE,oCAAA;EACA,gCAAA;AA9BN;AAiCI;EACE,oCAAA;EACA,gCAAA;AA/BN;;AAoCA;EACE;IACE,aAAA;EAjCF;EAqCE;IACE,aAAA;EAnCJ;EAyCM;IACE,eAAA;EAvCR;EA8CE;IACE,eAAA;EA5CJ;AACF","sourcesContent":["/* add-card.component.scss */\n.card-form-container {\n  padding: 24px;\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n  background: #ffffff;\n  border-radius: 16px;\n  box-sizing: border-box;\n}\n\n.form-header {\n  text-align: center;\n  margin-bottom: 32px;\n\n  .title {\n    font-size: 28px;\n    font-weight: 600;\n    color: #1a1f36;\n    margin-bottom: 8px;\n  }\n\n  .subtitle {\n    font-size: 15px;\n    color: #697386;\n    margin-bottom: 16px;\n  }\n\n  .accepted-cards {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    color: #697386;\n    font-size: 14px;\n\n    i {\n      font-size: 16px;\n      color: #ff5757;\n    }\n  }\n}\n\n.card-form {\n  .card-wrapper {\n    background-color: #ffffff;\n    border: 1px solid #e6e9ef;\n    border-radius: 12px;\n    padding: 24px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);\n    position: relative;\n    box-sizing: border-box;\n    width: 100%;\n  }\n\n  .secure-badge {\n    position: absolute;\n    top: -12px;\n    right: 16px;\n    background: #f7fafc;\n    border: 1px solid #e6e9ef;\n    border-radius: 20px;\n    padding: 6px 12px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: #697386;\n\n    i {\n      color: #ff5757;\n      font-size: 14px;\n    }\n  }\n\n  .card-field {\n    margin-bottom: 20px;\n    width: 100%;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    // Make CVV field narrower\n    &:last-child {\n      .ant-form-item-control-input {\n        max-width: 160px;\n      }\n    }\n\n    // Make expiry field narrower\n    &:nth-child(2) {\n      .ant-form-item-control-input {\n        max-width: 160px;\n      }\n    }\n  }\n\n  .stripe-element {\n    background-color: #ffffff;\n    border: 1px solid #e6e9ef;\n    border-radius: 8px;\n    padding: 12px;\n    transition: all 0.2s ease;\n    width: 100%;\n    box-sizing: border-box;\n\n    &:hover {\n      border-color: #ff5757;\n    }\n\n    &.StripeElement--focus {\n      border-color: #ff5757;\n      box-shadow: 0 0 0 3px rgba(255, 87, 87, 0.15);\n    }\n\n    &.StripeElement--invalid {\n      border-color: #ff5757;\n      box-shadow: 0 0 0 3px rgba(255, 87, 87, 0.1);\n    }\n  }\n}\n\n.form-footer {\n  margin-top: 24px;\n  display: flex;\n  justify-content: center;\n\n  button {\n    min-width: 200px;\n  }\n}\n\n:host ::ng-deep {\n  .ant-form-item {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0;\n    width: 100%;\n\n    .ant-form-item-label {\n      text-align: left;\n      margin-bottom: 8px;\n      padding: 0;\n\n      > label {\n        height: 20px;\n        line-height: 20px;\n        font-size: 14px;\n        color: #1a1f36;\n        font-weight: 500;\n\n        &::after {\n          display: none;\n        }\n      }\n    }\n\n    .ant-form-item-control {\n      min-height: unset;\n    }\n  }\n\n  .ant-form-item-control-input {\n    min-height: unset;\n  }\n\n  .ant-form-item-explain-error {\n    font-size: 13px;\n    color: #ff5757;\n    margin-top: 6px;\n  }\n\n  .ant-btn-primary {\n    background-color: #ff5757;\n    border-color: #ff5757;\n\n    &:hover {\n      background-color: #ff7070 !important;\n      border-color: #ff7070 !important;\n    }\n\n    &:active {\n      background-color: #e64d4d !important;\n      border-color: #e64d4d !important;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .card-form-container {\n    padding: 16px;\n  }\n\n  .card-form {\n    .card-wrapper {\n      padding: 20px;\n    }\n\n    .card-field {\n      &:last-child,\n      &:nth-child(2) {\n        .ant-form-item-control-input {\n          max-width: 100%;\n        }\n      }\n    }\n  }\n\n  .form-header {\n    .title {\n      font-size: 24px;\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
